import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'הקודם',
      changePassword: 'שנה/י סיסמה',
      copiedVaultId: 'הועתק!',
      copyVaultID: 'העתק את מזהה Vault',
      create: 'צור/צרי',
      next: 'הבא',
      notSure: 'אינני בטוח/ה',
      signUp: 'הירשם',
      submit: 'הגש',
      updatePassword: 'עדכן סיסמה',
    },
    Errors: {
      createReportFailed: 'יצירת דוח נכשלה.',
    },
    ReportStatus: {
      CLOSED: 'סגור',
      INVESTIGATING: 'בחקירה',
      NEW: 'הוגש',
      READ: 'נקרא',
    },
    general: {
      navbar: {
        caseSettings: 'הגדרות מקרה',
        changePassword: 'שנה סיסמה',
        logOut: 'התנתק',
        notifications: 'התראות',
        notificationsDrawer: {
          appFileScanFailed: 'קובץ נכשל בבדיקת האבטחה',
          appReportMatch: 'הרשומה שלך ב-GoTogether התאימה',
          appReportReassigned: 'מנהל התיק החדש שהוקצה',
          case: 'מקרה',
          caseAssigned: 'מקרה שהוקצה אליך',
          caseImporterJobCompleted: {
            PartialSuccess: 'הייבוא של התיק שלך הושלם עם שגיאות',
            failure: 'הייבוא של התיק שלך נכשל',
            success: 'הייבוא של התיק שלך הושלם בהצלחה',
          },
          caseLinked: 'מקרה מקושר',
          caseTeamInvite: 'התווסף לתיק',
          caseUnlinked: 'המקרה לא מחובר',
          dataSanitisation: 'פרטי הדוח עודכנו',
          emptyDescription: 'חזור מאוחר יותר לבדוק הודעות חדשות',
          emptyTitle: 'אתה מעודכן לחלוטין',
          importId: 'מזהה יבוא:',
          learnMore: 'למד עוד',
          markAllAsRead: 'סמן הכל כנקרא',
          newMessage: 'הודעה חדשה',
          newReport: 'דוח חדש התקבל',
          permissionRemoved: 'הוסר מהתיק',
          postSSubmissionFile: 'הוספת קובץ/קבצי ראייה',
          report: 'דוח',
          reportAssigned: 'דו"ח שהוקצה לך',
          reportStatusChange: 'מצב הדוח השתנה',
          reporterAnonymised: 'הפרטים שלך הופכו לאנונימיים',
          reporterReportSubmitted: {
            subtitle: 'אנו ממליצים לשמור עותק של הדוח שלך',
            title: 'דו"ח שהוגש',
          },
          mitigationPlanReminder: 'נדרש אישור תוכנית הפחתה',
          staleCase: 'מקרה שלא טופל',
        },
        privacyStatement: 'הצהרה על פרטיות',
        reporter: {
          myReports: 'הדוחות שלי',
        },
        settings: 'הגדרות',
        technicalSupport: 'תמיכה טכנית',
        title: 'חשבון',
      },
      time: {
        day: 'יום',
        days: 'ימים',
        hour: 'שעה',
        hours: 'שעות',
        minute: 'דקה',
        minutes: 'דקות',
        second: 'שני',
        seconds: 'שניות',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'אנונימי',
        autoTranslate: 'התרגום האוטומטי מושבת כברירת מחדל.',
        backToMessages: 'בחזרה להודעות',
        caseSettings: 'הגדרות מקרה.',
        changeInProfile:
          'אם אתה מעוניין לשנות את ההגדרה הזו, אתה יכול לעשות זאת בפרופיל שלך',
        deletedByMessage: 'נמחק על ידי {{author}}',
        deletedMessageLabel: 'הודעה זו נמחקה',
        description:
          'כאשר התרגום האוטומטי מופעל, כל הודעות הדוחות יתורגמו באופן אוטומטי באמצעות AI בהתאם לשפת ברירת המחדל\n          שנבחרה בדפדפן שלך.',
        descriptionSecondHalf:
          "הגרסה המקורית של כל ההודעות תמיד שמורה וניתן למצוא אותה בצ'אט.",
        messagePlaceholder: 'התחל להקליד...',
        messageSettings: 'הגדרות הודעות.',
        originalMessages: 'מקורי',
        showMoreBanner: 'למד עוד על תרגומים אוטומטיים',
        titlev2: 'קרא את כל ההודעות בשפה שאתה מעדיף.',
        translatedMessageLabel: 'הודעה מתורגמת',
        translatedMessages: 'מתורגם',
        understood: 'הבנתי',
      },
      Country: {
        description: 'באיזו מדינה אתה מבוסס?',
        header: 'באיזו מדינה אתה מבוסס?',
        noOptions: 'לא נמצאו מדינות',
        other: 'אחר',
        placeholder: 'חפש מדינה...',
      },
      CreatePublicReport: {
        createReport: 'צור/צרי דוח חדש',
        helpPage: 'עבור לעמוד העזרה שלנו',
        loginToOpr: 'התחבר למעקב אחר דוחות',
        or: 'או',
        passwordPlaceholder: 'הזן/הזיני סיסמה',
        phoneNumberLoginFailed:
          'התחברות נכשלה, מספר הטלפון / הקוד האישי לא נכונים',
        phoneNumberPlaceholder: 'הזן את מספר הטלפון שלך',
        phoneNumberTooltip:
          'הזן את מספר הטלפון שבו השתמשת כדי ליצור קשר עם VaultTalk',
        pinPlaceholder: 'הכנס קוד סודי',
        reportIntroductionParagraph1:
          'כאשר אתה מדווח על אירוע, ישאלו אותך מספר שאלות כדי לסייע לך בתיעוד החוויה שלך.',
        reportIntroductionParagraph2:
          'לפני שאתה מגיש, יש לך את האפשרות להישאר אנונימי כדי להגן על הפרטיות שלך.',
        reportIntroductionParagraph3:
          'לאחר שתגיש, באפשרותך להתחבר בכל זמן לראות את התקדמות הדוח שלך ולדבר עם מנהל התיק.',
        reportIssue: 'דווח/י על בעיה',
        usernameLoginFailed: 'התחברות נכשלה, שם משתמש/סיסמה שגויים',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'נדרשת קשר לחברה',
            reportedCategoryRequired: 'הקטגוריה המדווחת נדרשת',
          },
        },
        vaultId: 'זהות Vault',
        vaultIdPlaceholder: 'הכנס את האימייל שלך או את מספר הזיהוי של Vault',
        vaultIdTooltip:
          'לדוחות אנונימיים, מספר הזיהוי של Vault הוא אלפאנומרי. אם הדוח לא היה אנונימי, מספר הזיהוי של Vault הוא כתובת הדוא"ל שלך.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'הסיסמה שלך',
        yourPhoneNumber: 'מספר הטלפון שלך',
        yourPin: 'הקוד הבן 6 ספרות שלך',
        yourVaultId: 'ה-Vault ID שלך',
      },
      CustomHeader: {
        companyLogo: 'סמל של חברה',
        openReporting: 'פתח דיווח',
        userSettings: 'הגדרות משתמש',
      },
      Date: {
        approximateDescription: 'באיזה תאריך בערך התרחש האירוע?',
        approximatePlaceholder:
          'דוגמה: לפני 6 חודשים / בשנה שעברה/ בנובמבר האחרון',
        cancel: 'בטל/בטלי',
        clear: 'נקה/נקי',
        description: 'האם את/ה זוכר/ת את התאריך שבו התרחש האירוע?',
        header: 'באיזה יום זה התרחש?',
        ok: 'אישור',
        placeholder: 'דוגמה: 21 ביוני 2020',
      },
      Description: {
        whatHappened: 'מה קרה?',
        whatHappenedPlaceholder: 'השתמש/י במילים שלך...',
        whatHappenedText: 'תאר/י מה קרה במילים שלך',
      },
      Details: {
        disclaimer:
          'פרטים אלה יוחשפו עם הדוח שלך. אם אתה מעוניין להישאר אנונימי, ודא שהם לא מכילים מידע מזהה.',
        emailPlaceholder: 'כתובת דוא"ל (אופציונלי)',
        fullNamePlaceholder: 'שם מלא (אופציונלי)',
        header: 'הפרטים שלך',
        nonAnonSubtitle:
          'אנא ספק את שמך או כתובת הדוא"ל שלך. אם ברצונך לקבל התראות לגבי הדוח הזה, הוסף כתובת דוא"ל מתאימה למטה.',
        nonOptionalEmailPlaceholder: 'דוא"ל',
        nonOptionalFullNamePlaceholder: 'שם מלא',
        subtitle:
          'אם אתה רוצה לקבל התראות על דוח זה, הוסף כתובת דוא"ל מ appropriateת מטה.',
      },
      Emotion: {
        description: 'מה זה גרם לך להרגיש? מה הייתה ההשפעה?',
        header: 'מה הייתה ההשפעה?',
        placeholder: 'התחל/התחילי להקליד...',
      },
      Evidence: {
        addedHeading: 'הוסיף',
        deletedMessage: 'נמחק',
        deletedStatus: 'נמחק',
        failedToOpenFileMessage: 'נכשל בפתיחת הקובץ. אנא נסה שוב.',
        fileStatuses: {
          infectedUpload: 'מסומן על ידי בדיקת אבטחה',
          passedUpload: 'עבר בדיקת אבטחה',
          pendingUpload: 'ביצוע בדיקת אבטחה',
          readyForDownload: 'מוכן להורדה',
        },
        mobileErrorMessage: 'קבצים מסומנים: שלח הודעה למנהל התיק שלך',
        nameHeading: 'שם',
        statusHeading: 'מצב',
        tableTitle: 'ראיות',
        webErrorMessage:
          'קבצים מסומנים: אם הקובץ (ים) שלך סומן, אנא שלח הודעה למנהל התיק',
      },
      FileUpload: {
        addFiles: 'הוסף קבצים',
        addMoreFiles: 'הוסף קבצים נוספים',
        confirm: 'אשר',
        description:
          'הוספת קבצים כראיות יכולה לעזור לתמוך ביעילות ההחלטה של מנהל המקרה שלך. אנא שקל את תוכן הקובץ (כולל מטא-נתונים של הקובץ) אם אתה מעוניין להישאר אנונימי, ותכבד את זכויות האנשים האחרים והחוקים העומדים בתוקף.',
        dragDrop: 'השלם קבצים כאן או',
        errorMessage:
          'הקובץ/קבצים נכשל(ו) בשל שגיאת רשת. לחץ למטה כדי לשלוח הודעה למנהל התיק שלך לקבלת עזרה.',
        fileLimit: 'מגבלת גודל לכל קובץ: 100MB',
        fileUploadLimitText: 'אתה יכול להעלות רק 10 קבצים',
        header: 'הוסף ראיות',
        helpArticle: 'מאמר עזרה',
        highlighted: 'עיין בקבצים',
        information: 'סוגי קבצים נתמכים',
        moreInformation: 'למידע נוסף, ראה <a>מאמר עזרה</a>',
        postSubmissionErrorMessage:
          "לא הצלחנו להעלות את הקבצים שלך בשל שגיאה במערכת. אנא בחר שוב ב'אישור'.",
        tooltipAudio: 'אודיו:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'מסמכים:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'תמונות:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'טקסט:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'וידאו:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'הקובץ גדול מדי',
          invalidFileType: 'סוג קובץ לא נתמך: {{extension}}',
          systemError: 'שגיאת מערכת',
          tooManyFiles: 'המספר המרבי של קבצים הוא {{maxFiles}}',
        },
        uploadFiles: 'העלה קבצים',
      },
      Loading: {
        loading: 'אנא המתן במהלך שליחת הדוח שלך למנהל התיק...',
        postSubmissionLoading: 'אנא המתן בעת שאנו מגישים את הקובץ/קבצים שלך...',
      },
      Location: {
        description: 'איפה זה קרה?',
        header: 'איפה זה קרה?',
        placeholder: 'לדוגמה: במשרד',
      },
      MessageListBox: {
        messageCaseManager: 'שלח/י הודעה למנהל/ת פניות עובדים',
        report: 'דוח {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'תרגום מושבת',
        enableTranslationLabelEnabled: 'תרגום מופעל',
        enableTranslationsDescription:
          'אפשר תרגום אוטומטי וקרא את כל הודעות הדוח בשפה שאתה מעדיף. השפה המתורגמת מבוססת על השפה שנבחרה במכשיר שלך.',
        enableTranslationsHeader: 'אפשר תרגום אוטומטי של הודעות דוח',
        enableTranslationsSubDescriptionv2:
          "אתה יכול להחליף בין השפה המתורגמת לשפה המקורית בכל צ'אט.",
        updateTranslationFailed: 'העדכון של התרךמה נכשל',
        updateTranslationSuccess: 'ההגדרות לתרגום עודכנו בהצלחה',
      },
      Password: {
        changePasswordHeader: 'שנה/י סיסמה',
        createNewPassword: 'צור/צרי סיסמה חדשה',
        createPasswordHeader: 'הסיסמה שלך',
        currentPasswordPlaceholder: 'הזן/הזיני את הסיסמה הנוכחית',
        description:
          'סיסמה תקינה חייבת להכיל לפחות 9 תווים ולכלול לפחות אות גדולה אחת וספרה אחת',
        enterCurrentPassword: 'הזן/הזיני את הסיסמה הנוכחית',
        forgottenPasswordInstructions:
          'הזן את מספר הזהות שלך ב-Vault (לא כתובת האימייל שלך) וכתובת האימייל שלך כדי לאפס את הסיסמה שלך.',
        newDescription:
          'צור/צרי סיסמה חזקה כדי לשמור על חשבונך בטוח. התחל/י להקליד כדי לראות את ההנחיות למטה.',
        passwordPlaceholder: 'צור/צרי סיסמה',
        passwordResetRequestedDescription:
          'אם קיים מזהה Vault במערכת שלנו, תקבל/י מייל עם הוראות לאיפוס הסיסמה שלך.',
        passwordResetRequestedHeader: 'נדרש קישור לאיפוס סיסמה',
        reenterPlaceholder: 'הזן/הזיני שוב את הסיסמה',
        subtitle: 'צור/צרי סיסמה כדי להגיש דוח זה ולקבל גישה אליו בעתיד',
        yourVaultId: 'ה-Vault ID שלך',
        yourVaultIdPlaceholder:
          'הזן את מזהה ה-Vault שלך (לדוגמה, {{exampleId}})',
      },
      Perpetrators: {
        description:
          'האם את/ה מדווח/ת על אדם ספציפי או על כמה אנשים? האם תוכל/י לנקוב בשמם או לתאר אותם?',
        header: 'אנשים מעורבים',
        placeholder:
          'התחל/התחילי להקליד והשתמש/י בפסיק כדי להוסיף שמות או תיאורים מרובים',
      },
      PoweredByVault: 'מופעל באמצעות {{company}}',
      PrivacyStatement: 'הצהרת פרטיות למוצר',
      PublicMessageList: {
        myMessages: 'ההודעות שלי',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'הוספת ראיות לדוח הקיים',
        backToReportId: 'חזרה לדוח מספר: {{reportId}}',
        description:
          'הוספת קבצים כראיות יכולה לעזור לתמוך ביעילות של ההחלטה על ידי מנהל התיק שלך. אנא שקלו את תוכן הקובץ (כולל מטא-דאטה של הקובץ) אם אתה רוצה להישאר אנונימי, והכבד את זכויות האנשים האחרים והחוקים הרלוונטיים. לעוד מידע, אנא צפה בזה <a>מאמר עזרה</a>',
        header: 'הוסף ראיות נוספות לדוח',
        vaultTalkOpenCaseHeader: 'הוסף ראיות לדוח שלך',
      },
      PublicReport: {
        anonymous: 'בעילום שם',
        backToReports: 'בחזרה לדוחות',
        skipped: 'דולג',
      },
      PublicReportCard: {
        addEvidence: 'הוסף ראיות נוספות',
        messageCaseManager: 'שלח/י הודעה למנהל/ת פניות עובדים',
        reportId: 'מזהה הדוח:',
        submitted: 'הוגש',
        vaultTalkClosedCaseCTA: 'צפה בראיות',
        vaultTalkOpenCaseCTA: 'הוסף ראיות',
        viewAdditionalEvidence: 'צפה בראיות נוספות',
        viewReport: 'הצג/הציגי דוח',
      },
      PublicReportsList: {
        reportingSystem: 'מערכת דיווח',
      },
      Question: {
        placeholder: 'התחל להקליד...',
        question: 'ספק פרטים',
        questionText: 'אנא שתף איתנו את הדאגה, העדכון או החקירה שלך',
      },
      Relationship: {
        header: 'הקשר שלך לארגון',
        tellUsAbout: 'ספר/י לנו על הקשר שלך עם הארגון.',
      },
      ResponsiveNavMenu: {
        messages: 'ההודעות שלי',
        reports: 'הדוחות שלי',
      },
      Site: {
        description: 'באיזה אתר אתה מבוסס?',
        header: 'באיזה אתר אתה מבוסס?',
        noOptions: 'לא נמצאו אתרים',
        other: 'אחר',
        placeholder: 'חיפוש אתר...',
      },
      SpamPuzzle: {
        dialog: 'כדי להמשיך, פתור/פתרי חידה זו',
      },
      SubmissionTypes: {
        reportIssue: 'בחר קטגוריה',
        whatType: 'בחר את הקטגוריה שהכי טוב תיאר את הדוח שלך',
      },
      SubmitSuccess: {
        category: '<bold>קטגוריה:</bold> {{category}}',
        country: '<bold>מדינה:</bold> {{country}}',
        dateSubmitted: '<bold>תאריך הגשה:</bold> {{date}}',
        recordYourVaultID: 'זכור את המידע הזה להתחברות',
        successInformation: 'מידע נוסף',
        successMessage:
          'דוחך הוגש ומוכן לביקורת. כל הקבצים המצורפים שדורשים תשומת לב, יסומנו כאשר תתחבר למערכת. התחבר להלן כדי לצפות בעדכונים לדוח ולשלוח הודעות למנהל התיק שלך.',
        successSanitationMessage:
          'שמור עותק לרישומים שלך, ושמור את Vault-ID שלך בבטחה - אתה תצטרך אותו כדי לגשת לעדכונים ולשלוח הודעות למנהל התיק שלך.',
        successSanitationTagline: 'הדוח שלך הוגש ואוחסן באופן מאובטח.',
        successThankYou: 'תודה על הדוח שלך!',
        viewReport: 'צפה בדוח',
      },
      Time: {
        approximateDescription: 'בערך באיזו שעה התרחש האירוע?',
        approximatePlaceholder: 'לדוגמה: בבוקר, אחר הצהריים',
        description: 'האם את/ה זוכר/ת את השעה שבה התרחש האירוע?',
        header: 'באיזו שעה זה קרה?',
        invalidTime: 'תבנית זמן חייבת להיות HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'שנה/י סיסמה',
        closeDialog: 'סגור/סגרי תיבת דו-שיח',
        logout: 'התנתק/י',
        messageSettings: 'הגדרות הודעות',
        userSettings: 'הגדרות משתמש',
      },
      Witnesses: {
        description: 'האם סיפרת למישהו אחר, או האם מישהו ראה מה קרה?',
        header: 'היו עדים?',
        placeholder: 'התחל/התחילי להקליד...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'שלח הודעה',
        title: 'מנהל מקרים הודעה',
        translationHeader: 'מידע נוסף על תרגומים אוטומטיים',
      },
      ReportCard: {
        addEvidence: 'הוסף ראיות',
        submissionModeVia: 'דרך {{submissionMode}}',
        viewEvidence: 'הצג ראיות',
      },
      ReportList: {
        yourReports: 'הדוחות שלך',
      },
      ReportingActivate: {
        buttonText: 'המשך',
        description:
          'אם הארגון שלך רשם אתך לחשבון, אנחנו נשלח לך אימייל עם הוראות להשלמת ההתקנה.',
        emailInput: 'דוא"ל',
        header: 'הכנס את כתובת הדוא"ל של העבודה שלך',
        successAccount:
          'אם הארגון שלך רשם אותך לחשבון, אנחנו נשלח לך אימייל עם הוראות לסיום ההגדרה.',
        successEmail:
          'אם אתה לא רואה את זה מיד, אנא המתן מספר דקות ורענן את תיבת הדואר שלך.',
        successHeading: 'תודה',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'הוסף ראיות לדוח שלך',
        descriptionText:
          'הוספת קבצים כראיות יכולה לעזור לתמוך ביעילות ההחלטה של מנהל התיק שלך. אנא שקלו את תוכן הקובץ (כולל נתוני המטה של הקובץ) אם אתם רוצים להישאר אנונימיים, והכבדו את זכויות האנשים האחרים והחוקים הרלוונטיים. למידע נוסף, אנא עיינו ב- <a>מאמר העזרה</a> הזה.',
        emptyMessage: 'לא הועלו ראיות נוספות',
      },
      ReportingChangePassword: {
        back: 'חזרה',
        description:
          'צור סיסמה חזקה כדי לשמור על חשבונך מאובטח. התחל להקליד כדי לראות הנחיות למטה.',
        errorToast: 'לא ניתם ליצור סיסמה, אסימון לא חוקי.',
        header: 'שנה סיסמה',
        incorrectCurrentPassword:
          'הסיסמה הנוכחית שגויה. אנא בדוק אותה ונסה שוב.',
        invalidToken: 'אסימון לא חוקי',
        passwordUpdated: 'סיסמה עודכנה',
        passwordUpdatedDescription:
          'סיסמתך עודכנה בהצלחה. תודה שנקטת צעד זה כדי לשמור על אבטחת המידע שלך!',
        passwordUsedBefore: 'אינו מותר לשנות את הסיסמה',
        passwordUsedBeforeDescription:
          'למען בטחונך, אתה לא יכול להשתמש מחדש באחד מששת הסיסמאות האחרונות שלך. אנא בחר סיסמה חדשה וייחודית כדי לשמור על חשבונך מאובטח ונסה שוב.',
        toastDescription:
          'סיסמתך עודכנה בהצלחה. תודה שנקטת את הצעד הזה כדי לשמור על בטחון המידע שלך!',
        toastMessage: 'סיסמה עודכנה',
        updatePasswordCTA: 'עדכן סיסמה',
      },
      ReportingConnect: {
        cancelButton: 'בטל',
        connectButton: 'התחבר',
        disclaimer:
          'חיבור החשבון שלך ב-Slack עם החשבון שלך ב-Vault מבטיח חיבור בטוח ופרטי.<br /><br />בעזרת החיבור, תוכל לדווח عנייני התנהגות לא מתאימה או לשאול שאלה ישירות בתוך Slack. תמיד תהיה לך האפשרות לדווח באופן אנונימי לאחר החיבור. הפרטיות שלך והביטחון שלך הם העדפתנו העליונה.',
        heading:
          'Vault Platform מבקשת אישור לגשת לחשבון Slack של הארגון שלך {{organisationName}}',
        listHeading: 'מה Vault יוכל לעשות?',
        permissionIdentity: {
          extraInfo: 'Vault יהיה בעל היכולת להציג את זהות משתמש ה-Slack שלך.',
          heading: 'צפה במידע אודות זהותו של משתמש',
        },
        permissionNotifications: {
          extraInfo:
            'Vault יוכל לשלוח לך הודעות לחשבון Slack שלך, בנוגע לכל עדכונים לדוח או שאלה שהוגשו',
          heading: 'שלח לך התראות',
        },
        permissionOverview: {
          extraInfo: 'Vault יציג סקירה של כל ההגשות בעמוד הבית',
          heading: 'סקירה של ההגשות',
        },
        permissionSubmitReport: {
          extraInfo:
            'זה ייתן ל-Vault הרשאה להגיש דוח או לשאול שאלה, ישירות לארגון שלך, מ-Slack',
          heading: 'שלח דוח או שאלה בשמך',
        },
        successfulConnectionDescription:
          'חשבון Vault וחשבון Slack שלך מחוברים כעת. תוכל כעת לסגור את הכרטיסיה הזו ולחזור ל-Slack.',
        successfulConnectionHeading: 'מחובר בהצלחה',
        unsuccessfulConnectionDescription:
          'משהו השתבש. אנא סגור את הכרטיסיה וחזור ל- Slack כדי לנסות שוב.',
        unsuccessfulConnectionHeading: 'החיבור נכשל',
      },
      ReportingForgotPassword: {
        description:
          'הזן את כתובת הדוא"ל המשויכת לחשבונך, ואנו נשלח לך קישור לאיפוס הסיסמה שלך.',
        heading: 'סיסמה שנשכחה',
        invalidTokenError: 'לא ניתן ליצור סיסמה, אסימון לא חוקי.',
        passwordReuseError: 'אינו מותר להשתמש שוב באותה הסיסמה',
        passwordReuseErrorDescription:
          'למענך הביטחון, אתה לא יכול להשתמש שוב באף אחד מששת הסיסמאות האחרונות שלך. אנא בחר סיסמה חדשה וייחודית כדי לשמור על חשבונך מאובטח ונסה שוב.',
        sendLink: 'שלח קישור לאיפוס',
        sendLinkFailure: 'משהו השתבש',
        sendLinkFailureDescription:
          'חזור אל <a>מרכז הדיווח</a> ונסה שוב. אם הבעיה ממשיכה, צור איתנו קשר ב- <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'קישור לאיפוס סיסמה נשלח',
        sendLinkSuccessDescription: 'שלחנו קישור לאיפוס הסיסמה אל {{email}}',
        updatePasswordSuccess: 'סיסמה עודכנה',
        updatePasswordSuccessDescription:
          'סיסמתך עודכנה בהצלחה. תודה שנקפת צעד זה לשמירה על בטחון המידע שלך!',
      },
      ReportingLogin: {
        accountFrozen: 'חשבון נחסם',
        accountLocked:
          'ניסו להתחבר פעמים רבות מדי לא בצורה מדויקת. החשבון ננעל למשך עד שעה. אינך יכול לאפס את הסיסמה במהלך זמן זה.',
        accountLockedPermanently:
          'חשבונך ננעל. השתמש באפשרות איפוס סיסמה כדי לשחזר את הגישה או פנה למנהל המערכת שלך לעזרה נוספת.',
        createAccountCTA: 'הירשם לחשבון',
        currentPassword: 'סיסמה נוכחית',
        emailLabel: 'האימייל שלך',
        forgotPassword: 'שכחת את הסיסמה שלך?',
        loginButton: 'כניסה',
        newPasswordPlaceholder: 'סיסמה חדשה',
        passwordFailMessage:
          'חזור לאפליקציה של Vault ב-Slack ונסה שוב. אם הבעיה ממשיכה, צור איתנו קשר ב techsupport@vaultplatform.com.',
        passwordFailTitle: 'משהו השתבש',
        passwordLabel: 'הסיסמה שלך',
        passwordPlaceholder: 'הכנס את הסיסמה שלך',
        passwordResetRequired: 'נדרש איפוס סיסמה',
        passwordSuccessfullySetMessage:
          'חזור לאפליקציה של Vault ב-Slack ואמת באמצעות סיסמתך החדשה כדי להמשיך מהיכן שנותרת.',
        passwordSuccessfullySetTitle: 'הסיסמה הוגדרה בהצלחה',
        reenterPlaceholder: 'הזן מחדש את הסיסמה',
        title: 'מרכז הדיווח',
        tooltip:
          'אם לא קבעת עדיין סיסמה לאפליקציית Vault, עקוב כאן כדי להתחיל. אם שכחת את הסיסמה שלך, השתמש בקישור "שכחתי סיסמה" שמתחת.',
        usernameLoginFailed: 'התחברות נכשלה, שם משתמש או סיסמה שגויים',
      },
      ReportingReset: {
        failureDescription:
          'חזור לאפליקצית Vault ב-Slack ונסה שוב. אם הבעיה ממשיכה, צור קשר איתנו ב- <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'משהו השתבש',
        successDescription:
          "חזור לאפליקציה 'Vault' ב-Slack ואמת עם הסיסמה החדשה שלך כדי להמשיך מהיכן שעצרת",
        successHeading: 'הסיסמה הוגדרה בהצלחה',
      },
      noReports: {
        description:
          'כל הדוחות שהוגשו יופיעו כאן. למד עוד על הדרכים שבהן אתה יכול להגיש דוח.',
        descriptionHelpArticle: 'מאמר עזרה זה',
        errorDescription:
          'אנחנו מתקשים לטעון את הדוחות שלך. אנא נסה לרענן את העמוד.',
        errorDescriptionSecondary: 'אם זה לא עובד, אנא פנה אלינו ב',
        errorTitle: '⚠️ אופס, משהו השתבש',
        title: 'אין לך דוחות עדיין',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'אפשר התרגום אוטומטי וקרא את כל הודעות הדוח בשפה המועדפת עליך. השפה שנתרגמה מבוססת על השפה שנבחרה במכשיר שלך.',
          autoTranslationDescription2:
            "אתה יכול להחליף בין השפה המתורגמת לבין השפה המקורית בכל צ'אט.",
          autoTranslationTitle: 'אפשר תרגום אוטומטי להודעות דוח',
          header: 'הגדרות הודעה',
          subHeader: 'קבע את אופן הצגת ההודעות',
        },
        notificationSettings: {
          emailDescription: 'קבל הודעות בדוא"ל לעדכונים חשובים בדוחות שלך',
          emailTitle: 'הודעות דוא"ל',
          header: 'הגדרות התראות',
          subHeader: 'הגדר איך אתה מקבל התראות',
        },
        title: 'הגדרות',
        updatedSettingsFailure: 'נכשל בעדכון ההגדרות שלך',
        updatedSettingsSuccess: 'עדכנת בהצלחה את ההגדרות שלך',
      },
    },
    validators: {
      passwordLength: 'הסיסמה חייבת לכלול לפחות 9 תווים',
      passwordLowercase: 'הסיסמה חייבת לכלול לפחות אות קטנה אחת',
      passwordMissMatch: 'השדה סיסמה והשדה אימות סיסמה חייבים להתאים.',
      passwordNumeric: 'הסיסמה חייבת לכלול לפחות ספרה אחת',
      passwordUppercase: 'הסיסמה חייבת לכלול לפחות אות גדולה אחת',
    },
    validatorsNew: {
      passwordLength: 'בין 10 ל-30 תווים',
      passwordLowercase: 'לפחות אות אחת קטנה',
      passwordMissMatch: 'הסיסמאות אינן תואמות',
      passwordNumeric: 'לפחות מספר אחד',
      passwordSpecialCharacter: 'לפחות תו מיוחד אחד',
      passwordUppercase: 'לפחות אות גדולה אחת',
    },
  },
};

export default translations;
